<div>
    <div class="description py-3">
        <p>Select the type of school system and the specific school or system you are currently employed by or planning to apply to.</p>
    </div>
    <div class="container">
        <div class="row">
            <div class="px-2 pt-3">
                <div class="row form-group">
                    <div class="col-sm-12 col-md-6">
                        <app-form-control type="select" [form]="interalForm" title="School Type"
                            placeholder="Select a school type" controlName="siteType"
                            [data]="siteTypeList"></app-form-control>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <app-form-control type="select" [form]="interalForm" title="School / System"
                            placeholder="Select a school or system" controlName="schoolSystem"
                            [data]="schoolSystemList"></app-form-control>
                    </div>
                </div>
            </div>
        </div>

        <div class="my-3" *ngIf="jsonData.systemName">
            <div class="row overflow-auto">
                <table class="table table-striped table-mobile-responsive table-mobile-sided">
                    <thead>
                        <tr>
                            <th scope="col">School Type</th>
                            <th scope="col">System Name</th>
                            <th scope="col">Site Name</th>
                            <th scope="col">Site Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td data-content="School Type">{{jsonData.siteTypeDescription}}</td>
                            <td data-content="System Name">{{jsonData.systemName}}</td>
                            <td data-content="Site Name">{{jsonData.siteLongName || jsonData.siteName}}</td>
                            <td data-content="Site Code">{{jsonData.siteCode}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
